import React from 'react';

const FooterSeo = () => {
    return (
        <p className="text-center social-links">
            <a className="social-link" href="https://www.facebook.com/ailsa.lyn.7" target="_blank">
                <i className="fa fa-facebook-square" aria-hidden="true" />
            </a>
            <a className="social-link" href="https://twitter.com/lynailsa" target="_blank">
                <i className="fa fa-twitter-square" aria-hidden="true" />
            </a>
        </p>
    );
};

export default FooterSeo;



// WEBPACK FOOTER //
// ./src/components/common/FooterSeo.js